module.exports = __webpack_public_path__ + "img/14.fe00ccbb.jpg";